import {
  getCitizenshipQuestion,
  IDTypes,
  type PropertyIdentificationConfig,
  type TaxIdTypeDetail,
} from '@common/entities';
import { getIdTypeTemplate } from '@common/ui';

import type { IdOption } from 'types/fields';
import type { Form } from 'types/form';

export function mergePropertyIdentificationConfig(form: Form, configuredForm?: Form): Form {
  if (!configuredForm?.identificationConfig) return form;

  return {
    ...form,
    identificationConfig: configuredForm.identificationConfig,
  };
}

export function getPropertyIdentificationConfig(
  applicationConfig?: PropertyIdentificationConfig,
  leadProfileConfig?: PropertyIdentificationConfig,
): PropertyIdentificationConfig | undefined {
  return applicationConfig ?? leadProfileConfig;
}

export function resolveCitizenQuestion(
  fallback: string,
  config?: PropertyIdentificationConfig,
): string {
  return getCitizenshipQuestion(config, fallback);
}

function getTaxIdDetail(
  idType: string,
  taxIdTypes?: TaxIdTypeDetail[],
): TaxIdTypeDetail | undefined {
  const normalizedIdType = normalizeIdType(idType);
  return taxIdTypes?.find(
    (taxIdType) =>
      normalizeIdType(taxIdType.abbreviation) === normalizedIdType ||
      (taxIdType.id === 1 && normalizedIdType === normalizeIdType('Social Security Number')),
  );
}

function normalizeIdType(idType: string): string {
  return idType.replace(/[\s_-]/g, '').toLowerCase();
}

export function resolvePrimaryIdForProperty(
  primaryId: IdOption,
  config?: PropertyIdentificationConfig,
  citizenStatus?: boolean | string,
): IdOption {
  const requestedCategory =
    citizenStatus === false || citizenStatus === 'no' ? 'non_citizen' : 'citizen';
  const detail =
    config?.taxIdTypes?.find((taxIdType) => taxIdType.category === requestedCategory) ??
    config?.taxIdTypes?.find((taxIdType) => !taxIdType.category) ??
    config?.taxIdTypes?.[0];
  if (!detail || !primaryId.idTypes[0]) return primaryId;

  const currentType = normalizeIdType(primaryId.idTypes[0].customType);
  const isTaxId =
    currentType === normalizeIdType('Social Security Number') ||
    currentType === normalizeIdType(detail.abbreviation);
  if (!isTaxId) return primaryId;

  return {
    ...primaryId,
    idTypes: [
      {
        ...getIdTypeTemplate(
          detail.id === 1 ? IDTypes.SocialSecurityNumber : detail.abbreviation,
          getTaxIdDetail(detail.abbreviation, [detail]),
        ),
        taxIdTypeId: detail.id,
      },
    ],
  };
}
